<template>
  <div id="kt_header" class="header" data-kt-sticky="true" data-kt-sticky-name="header" data-kt-sticky-offset="{default: '200px', lg: '300px'}">
    <div class="container-xxl d-flex align-items-center justify-content-between" id="kt_header_container">
      <div class="d-flex d-lg-none align-items-center ms-n2 me-2">
        <div class="btn btn-icon btn-active-icon-primary" id="kt_aside_mobile_toggle">
          <i class="ki-duotone ki-abstract-14 fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>
      <router-link :to="{ name: 'Index' }" class="d-flex align-items-center center-header-logo">
        <img alt="Logo" :src="require('@/assets/logo.svg')" class="h-30px" />
      </router-link>
      <div class="page-title d-flex flex-column align-items-start justify-content-center flex-wrap mt-n5 mt-lg-0 me-lg-2 pb-2 pb-lg-0" data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_content_container', lg: '#kt_header_container'}">
        <h1 id="pageNameMain" class="text-dark fw-bold my-0 fs-2 mb-2">{{ pageTitle }}</h1>
        <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0">
          <template v-if="pageTitle !== 'Главная'">
            <li class="breadcrumb-item text-muted">
              <router-link  class="text-muted text-hover-primary" :to="{name: 'Index'}">Главная</router-link>
            </li>
            <li class="breadcrumb-item">
              <span class="bullet bg-gray-500 w-5px h-2px"></span>
            </li>
            <li id="pageName" class="breadcrumb-item text-gray-900">{{ pageTitle }}</li>
          </template>
          <li v-else class="breadcrumb-item text-muted">
            <span class="text-muted text-hover-primary">Главная</span>
          </li>
        </ul>
      </div>
      <div class="d-flex flex-shrink-0">
        <div class="d-flex align-items-center ms-3">
          <router-link :to="{ name: 'Profile' }" class="btn btn-icon flex-center bg-body btn-color-gray-600 btn-active-color-primary h-40px">
            <i class="ki-duotone ki-profile-circle fs-1">
              <span class="path1"></span>
              <span class="path2"></span>
              <span class="path3"></span>
            </i>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VHeader',
  computed: {
    pageTitle() {
      return this.$store.state.layoutPageTitle ?? this.$route.meta.title
    },
  },
}
</script>

<style scoped>

</style>